export default __webpack_public_path__ + "static/media/plodelogo.00401dbe.svg";